import React, { lazy } from 'react';
import { motion } from 'framer-motion';
import { WifiIcon } from 'lucide-react';
export function ShopSection() {
  return <section className="py-10 md:py-20 bg-brand-darkest relative overflow-hidden" id="shop" data-id="element-405">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-406">
        {/* Header */}
        <div className="text-center max-w-3xl mx-auto mb-8 md:mb-16" data-id="element-407">
          <motion.h2 initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5
        }} className="text-2xl sm:text-4xl md:text-5xl lg:text-6xl font-heading font-black mb-3" data-id="element-408">
            Choose Your Nation.{' '}
            <span className="text-gradient" data-id="element-409">Wear Your Pride.</span>
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.1
        }} className="text-gray-400 text-xs md:text-lg" data-id="element-410">
            Select from 32+ national teams. First drop limited to 5,000 units.
          </motion.p>
        </div>

        {/* Product Grid */}
        <div className="grid grid-cols-2 lg:grid-cols-3 gap-3 md:gap-8" data-id="element-411">
          {/* USA Card */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.1
        }} className="glass-card overflow-hidden flex flex-col" data-id="element-412">
            <div className="relative h-52 sm:h-56 md:h-80 flex items-center justify-center p-3 md:p-4 overflow-hidden" style={{
            background: 'linear-gradient(160deg, #0c1220 0%, #0a1628 40%, #081430 70%, #060e1e 100%)'
          }} data-id="element-413">
              <div className="absolute inset-0 opacity-20" style={{
              backgroundImage: 'radial-gradient(circle, rgba(0,102,255,0.4) 1px, transparent 1px)',
              backgroundSize: '14px 14px'
            }} data-id="element-414" />
              <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_50%_55%,rgba(26,42,94,0.2)_0%,rgba(0,102,255,0.08)_35%,transparent_65%)]" data-id="element-415" />
              <div className="absolute top-0 left-[10%] right-[10%] h-px bg-gradient-to-r from-transparent via-blue-400/40 to-transparent" data-id="element-416" />
              <div className="absolute top-2 right-2 md:top-4 md:right-4 z-10 bg-black/40 backdrop-blur-sm border border-brand-cyan/20 rounded-full px-2 py-1 md:px-3 md:py-1.5 flex items-center gap-1" data-id="element-417">
                <WifiIcon className="w-2.5 h-2.5 md:w-3 md:h-3 text-brand-cyan" data-id="element-418" />
                <span className="text-[8px] md:text-[10px] font-bold uppercase tracking-wider text-white" data-id="element-419">
                  NFC
                </span>
              </div>
              <div className="relative h-full w-auto z-[3] shirt-scale-default" style={{
              isolation: 'isolate'
            }} data-id="element-420">
                <img src="https://cdn.magicpatterns.com/uploads/r4wuUu22eUCuW6mGUaEdzy/ChatGPT_Image_Apr_21,_2026,_12_02_18_PM.png" alt="USA QTAP Smart T-Shirt" loading="lazy" className="h-full w-auto object-contain select-none pointer-events-none" style={{
                mixBlendMode: 'screen',
                filter: 'contrast(1.15) saturate(1.25) brightness(1.05)'
              }} draggable={false} data-id="element-421" />
              </div>
            </div>
            <div className="p-3 md:p-6 flex-grow flex flex-col justify-between bg-brand-dark/50" data-id="element-422">
              <div className="flex justify-between items-start mb-3 md:mb-6" data-id="element-423">
                <div data-id="element-424">
                  <h3 className="text-sm md:text-xl font-heading font-bold text-white mb-0.5" data-id="element-425">
                    USA
                  </h3>
                  <p className="text-[10px] md:text-xs text-gray-400" data-id="element-426">
                    QTAP Smart T-Shirt
                  </p>
                </div>
                <div className="flex flex-col items-end" data-id="element-427">
                  <span className="text-sm md:text-lg font-heading font-bold text-brand-cyan" data-id="element-428">
                    $69.95
                  </span>
                  <span className="text-[10px] md:text-xs text-gray-500 line-through" data-id="element-429">
                    $99.95
                  </span>
                </div>
              </div>
              <a href="https://shop.qtap.me/collections/world-cup-2026-smart-t-shirt" target="_blank" rel="noopener noreferrer" className="w-full block text-center py-2 md:py-3 px-3 border border-white/20 rounded-lg text-xs md:text-sm font-bold text-white hover:bg-brand-cyan hover:border-brand-cyan transition-all duration-300" data-id="element-430">
                Order Now
              </a>
            </div>
          </motion.div>

          {/* Brazil Card */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.15
        }} className="glass-card overflow-hidden flex flex-col" data-id="element-431">
            <div className="relative h-52 sm:h-56 md:h-80 flex items-center justify-center p-3 md:p-4 overflow-hidden" style={{
            background: 'linear-gradient(160deg, #0c1220 0%, #0a1628 40%, #081430 70%, #060e1e 100%)'
          }} data-id="element-432">
              <div className="absolute inset-0 opacity-20" style={{
              backgroundImage: 'radial-gradient(circle, rgba(0,102,255,0.4) 1px, transparent 1px)',
              backgroundSize: '14px 14px'
            }} data-id="element-433" />
              <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_50%_55%,rgba(200,170,0,0.15)_0%,rgba(0,102,255,0.08)_35%,transparent_65%)]" data-id="element-434" />
              <div className="absolute top-0 left-[10%] right-[10%] h-px bg-gradient-to-r from-transparent via-yellow-400/40 to-transparent" data-id="element-435" />
              <div className="absolute top-2 right-2 md:top-4 md:right-4 z-10 bg-black/40 backdrop-blur-sm border border-brand-cyan/20 rounded-full px-2 py-1 md:px-3 md:py-1.5 flex items-center gap-1" data-id="element-436">
                <WifiIcon className="w-2.5 h-2.5 md:w-3 md:h-3 text-brand-cyan" data-id="element-437" />
                <span className="text-[8px] md:text-[10px] font-bold uppercase tracking-wider text-white" data-id="element-438">
                  NFC
                </span>
              </div>
              <div className="relative h-full w-auto z-[3] shirt-scale-default" style={{
              isolation: 'isolate'
            }} data-id="element-439">
                <img src="https://cdn.magicpatterns.com/uploads/sS74oHsZNYx6gwWVLnKo55/shirt_transparent_2.png" alt="Brazil QTAP Smart T-Shirt" loading="lazy" className="h-full w-auto object-contain select-none pointer-events-none" style={{
                mixBlendMode: 'screen',
                filter: 'contrast(1.15) saturate(1.25) brightness(1.05)'
              }} draggable={false} data-id="element-440" />
              </div>
            </div>
            <div className="p-3 md:p-6 flex-grow flex flex-col justify-between bg-brand-dark/50" data-id="element-441">
              <div className="flex justify-between items-start mb-3 md:mb-6" data-id="element-442">
                <div data-id="element-443">
                  <h3 className="text-sm md:text-xl font-heading font-bold text-white mb-0.5" data-id="element-444">
                    Brazil
                  </h3>
                  <p className="text-[10px] md:text-xs text-gray-400" data-id="element-445">
                    QTAP Smart T-Shirt
                  </p>
                </div>
                <div className="flex flex-col items-end" data-id="element-446">
                  <span className="text-sm md:text-lg font-heading font-bold text-brand-cyan" data-id="element-447">
                    $69.95
                  </span>
                  <span className="text-[10px] md:text-xs text-gray-500 line-through" data-id="element-448">
                    $99.95
                  </span>
                </div>
              </div>
              <a href="https://shop.qtap.me/collections/world-cup-2026-smart-t-shirt" target="_blank" rel="noopener noreferrer" className="w-full block text-center py-2 md:py-3 px-3 border border-white/20 rounded-lg text-xs md:text-sm font-bold text-white hover:bg-brand-cyan hover:border-brand-cyan transition-all duration-300" data-id="element-449">
                Order Now
              </a>
            </div>
          </motion.div>

          {/* Argentina Card */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.2
        }} className="glass-card overflow-hidden flex flex-col" data-id="element-450">
            <div className="relative h-52 sm:h-56 md:h-80 flex items-center justify-center p-3 md:p-4 overflow-hidden" style={{
            background: 'linear-gradient(160deg, #0c1220 0%, #0a1628 40%, #081430 70%, #060e1e 100%)'
          }} data-id="element-451">
              <div className="absolute inset-0 opacity-20" style={{
              backgroundImage: 'radial-gradient(circle, rgba(0,102,255,0.4) 1px, transparent 1px)',
              backgroundSize: '14px 14px'
            }} data-id="element-452" />
              <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_50%_55%,rgba(74,144,217,0.15)_0%,rgba(0,102,255,0.08)_35%,transparent_65%)]" data-id="element-453" />
              <div className="absolute top-0 left-[10%] right-[10%] h-px bg-gradient-to-r from-transparent via-sky-400/40 to-transparent" data-id="element-454" />
              <div className="absolute top-2 right-2 md:top-4 md:right-4 z-10 bg-black/40 backdrop-blur-sm border border-brand-cyan/20 rounded-full px-2 py-1 md:px-3 md:py-1.5 flex items-center gap-1" data-id="element-455">
                <WifiIcon className="w-2.5 h-2.5 md:w-3 md:h-3 text-brand-cyan" data-id="element-456" />
                <span className="text-[8px] md:text-[10px] font-bold uppercase tracking-wider text-white" data-id="element-457">
                  NFC
                </span>
              </div>
              <div className="relative h-full w-auto z-[3] shirt-scale-argentina" style={{
              isolation: 'isolate'
            }} data-id="element-458">
                <img src="https://cdn.magicpatterns.com/uploads/njVWZDyXK3EAoQh1nJWuRG/ChatGPT_Image_Apr_21,_2026,_12_10_31_PM.png" alt="Argentina QTAP Smart T-Shirt" loading="lazy" className="h-full w-auto object-contain select-none pointer-events-none" style={{
                mixBlendMode: 'screen',
                filter: 'contrast(1.15) saturate(1.25) brightness(1.05)'
              }} draggable={false} data-id="element-459" />
              </div>
            </div>
            <div className="p-3 md:p-6 flex-grow flex flex-col justify-between bg-brand-dark/50" data-id="element-460">
              <div className="flex justify-between items-start mb-3 md:mb-6" data-id="element-461">
                <div data-id="element-462">
                  <h3 className="text-sm md:text-xl font-heading font-bold text-white mb-0.5" data-id="element-463">
                    Argentina
                  </h3>
                  <p className="text-[10px] md:text-xs text-gray-400" data-id="element-464">
                    QTAP Smart T-Shirt
                  </p>
                </div>
                <div className="flex flex-col items-end" data-id="element-465">
                  <span className="text-sm md:text-lg font-heading font-bold text-brand-cyan" data-id="element-466">
                    $69.95
                  </span>
                  <span className="text-[10px] md:text-xs text-gray-500 line-through" data-id="element-467">
                    $99.95
                  </span>
                </div>
              </div>
              <a href="https://shop.qtap.me/collections/world-cup-2026-smart-t-shirt" target="_blank" rel="noopener noreferrer" className="w-full block text-center py-2 md:py-3 px-3 border border-white/20 rounded-lg text-xs md:text-sm font-bold text-white hover:bg-brand-cyan hover:border-brand-cyan transition-all duration-300" data-id="element-468">
                Order Now
              </a>
            </div>
          </motion.div>

          {/* Germany Card */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.25
        }} className="glass-card overflow-hidden flex flex-col" data-id="element-469">
            <div className="relative h-52 sm:h-56 md:h-80 flex items-center justify-center p-3 md:p-4 overflow-hidden" style={{
            background: 'linear-gradient(160deg, #0c1220 0%, #0a1628 40%, #081430 70%, #060e1e 100%)'
          }} data-id="element-470">
              <div className="absolute inset-0 opacity-20" style={{
              backgroundImage: 'radial-gradient(circle, rgba(0,102,255,0.4) 1px, transparent 1px)',
              backgroundSize: '14px 14px'
            }} data-id="element-471" />
              <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_50%_55%,rgba(200,170,0,0.15)_0%,rgba(0,102,255,0.08)_35%,transparent_65%)]" data-id="element-472" />
              <div className="absolute top-0 left-[10%] right-[10%] h-px bg-gradient-to-r from-transparent via-yellow-400/40 to-transparent" data-id="element-473" />
              <div className="absolute top-2 right-2 md:top-4 md:right-4 z-10 bg-black/40 backdrop-blur-sm border border-brand-cyan/20 rounded-full px-2 py-1 md:px-3 md:py-1.5 flex items-center gap-1" data-id="element-474">
                <WifiIcon className="w-2.5 h-2.5 md:w-3 md:h-3 text-brand-cyan" data-id="element-475" />
                <span className="text-[8px] md:text-[10px] font-bold uppercase tracking-wider text-white" data-id="element-476">
                  NFC
                </span>
              </div>
              <div className="relative h-full w-auto z-[3] shirt-scale-large" style={{
              isolation: 'isolate'
            }} data-id="element-477">
                <img src="https://cdn.magicpatterns.com/uploads/eurp1DbxYJ8irF5ACLirpV/ChatGPT_Image_Apr_21,_2026,_11_41_38_AM.png" alt="Germany QTAP Smart T-Shirt" loading="lazy" className="h-full w-auto object-contain select-none pointer-events-none" style={{
                mixBlendMode: 'screen',
                filter: 'contrast(1.15) saturate(1.25) brightness(1.05)'
              }} draggable={false} data-id="element-478" />
              </div>
            </div>
            <div className="p-3 md:p-6 flex-grow flex flex-col justify-between bg-brand-dark/50" data-id="element-479">
              <div className="flex justify-between items-start mb-3 md:mb-6" data-id="element-480">
                <div data-id="element-481">
                  <h3 className="text-sm md:text-xl font-heading font-bold text-white mb-0.5" data-id="element-482">
                    Germany
                  </h3>
                  <p className="text-[10px] md:text-xs text-gray-400" data-id="element-483">
                    QTAP Smart T-Shirt
                  </p>
                </div>
                <div className="flex flex-col items-end" data-id="element-484">
                  <span className="text-sm md:text-lg font-heading font-bold text-brand-cyan" data-id="element-485">
                    $69.95
                  </span>
                  <span className="text-[10px] md:text-xs text-gray-500 line-through" data-id="element-486">
                    $99.95
                  </span>
                </div>
              </div>
              <a href="https://shop.qtap.me/collections/world-cup-2026-smart-t-shirt" target="_blank" rel="noopener noreferrer" className="w-full block text-center py-2 md:py-3 px-3 border border-white/20 rounded-lg text-xs md:text-sm font-bold text-white hover:bg-brand-cyan hover:border-brand-cyan transition-all duration-300" data-id="element-487">
                Order Now
              </a>
            </div>
          </motion.div>

          {/* Spain Card */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.3
        }} className="glass-card overflow-hidden flex flex-col" data-id="element-488">
            <div className="relative h-52 sm:h-56 md:h-80 flex items-center justify-center p-3 md:p-4 overflow-hidden" style={{
            background: 'linear-gradient(160deg, #0c1220 0%, #0a1628 40%, #081430 70%, #060e1e 100%)'
          }} data-id="element-489">
              <div className="absolute inset-0 opacity-20" style={{
              backgroundImage: 'radial-gradient(circle, rgba(0,102,255,0.4) 1px, transparent 1px)',
              backgroundSize: '14px 14px'
            }} data-id="element-490" />
              <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_50%_55%,rgba(0,102,255,0.12)_0%,rgba(0,102,255,0.06)_35%,transparent_65%)]" data-id="element-491" />
              <div className="absolute top-0 left-[10%] right-[10%] h-px bg-gradient-to-r from-transparent via-blue-400/40 to-transparent" data-id="element-492" />
              <div className="absolute top-2 right-2 md:top-4 md:right-4 z-10 bg-black/40 backdrop-blur-sm border border-brand-cyan/20 rounded-full px-2 py-1 md:px-3 md:py-1.5 flex items-center gap-1" data-id="element-493">
                <WifiIcon className="w-2.5 h-2.5 md:w-3 md:h-3 text-brand-cyan" data-id="element-494" />
                <span className="text-[8px] md:text-[10px] font-bold uppercase tracking-wider text-white" data-id="element-495">
                  NFC
                </span>
              </div>
              <div className="relative h-full w-auto z-[3] shirt-scale-large" style={{
              isolation: 'isolate'
            }} data-id="element-496">
                <img src="https://cdn.magicpatterns.com/uploads/4SJDNFXCZmx9t4y64qeWAX/ChatGPT_Image_Apr_21,_2026,_11_44_27_AM.png" alt="Spain QTAP Smart T-Shirt" loading="lazy" className="h-full w-auto object-contain select-none pointer-events-none" style={{
                mixBlendMode: 'screen',
                filter: 'contrast(1.15) saturate(1.25) brightness(1.05)'
              }} draggable={false} data-id="element-497" />
              </div>
            </div>
            <div className="p-3 md:p-6 flex-grow flex flex-col justify-between bg-brand-dark/50" data-id="element-498">
              <div className="flex justify-between items-start mb-3 md:mb-6" data-id="element-499">
                <div data-id="element-500">
                  <h3 className="text-sm md:text-xl font-heading font-bold text-white mb-0.5" data-id="element-501">
                    Spain
                  </h3>
                  <p className="text-[10px] md:text-xs text-gray-400" data-id="element-502">
                    QTAP Smart T-Shirt
                  </p>
                </div>
                <div className="flex flex-col items-end" data-id="element-503">
                  <span className="text-sm md:text-lg font-heading font-bold text-brand-cyan" data-id="element-504">
                    $69.95
                  </span>
                  <span className="text-[10px] md:text-xs text-gray-500 line-through" data-id="element-505">
                    $99.95
                  </span>
                </div>
              </div>
              <a href="https://shop.qtap.me/collections/world-cup-2026-smart-t-shirt" target="_blank" rel="noopener noreferrer" className="w-full block text-center py-2 md:py-3 px-3 border border-white/20 rounded-lg text-xs md:text-sm font-bold text-white hover:bg-brand-cyan hover:border-brand-cyan transition-all duration-300" data-id="element-506">
                Order Now
              </a>
            </div>
          </motion.div>

          {/* Mexico Card */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.35
        }} className="glass-card overflow-hidden flex flex-col" data-id="element-507">
            <div className="relative h-52 sm:h-56 md:h-80 flex items-center justify-center p-3 md:p-4 overflow-hidden" style={{
            background: 'linear-gradient(160deg, #0c1220 0%, #0a1628 40%, #081430 70%, #060e1e 100%)'
          }} data-id="element-508">
              <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_50%_55%,rgba(26,92,42,0.2)_0%,rgba(0,102,255,0.08)_35%,transparent_65%)]" data-id="element-509" />
              <div className="absolute top-0 left-[10%] right-[10%] h-px bg-gradient-to-r from-transparent via-green-400/40 to-transparent" data-id="element-510" />
              <div className="absolute top-2 right-2 md:top-4 md:right-4 z-10 bg-black/40 backdrop-blur-sm border border-brand-cyan/20 rounded-full px-2 py-1 md:px-3 md:py-1.5 flex items-center gap-1" data-id="element-511">
                <WifiIcon className="w-2.5 h-2.5 md:w-3 md:h-3 text-brand-cyan" data-id="element-512" />
                <span className="text-[8px] md:text-[10px] font-bold uppercase tracking-wider text-white" data-id="element-513">
                  NFC
                </span>
              </div>
              <div className="relative h-full w-auto z-[3] shirt-scale-default" style={{
              isolation: 'isolate'
            }} data-id="element-514">
                <img src="https://cdn.magicpatterns.com/uploads/fywKWsm4rEgF6PWNx1tvRM/mexico_shirt_transparent.png" alt="Mexico QTAP Smart T-Shirt" loading="lazy" className="h-full w-auto object-contain select-none pointer-events-none" style={{
                mixBlendMode: 'screen',
                filter: 'contrast(1.15) saturate(1.25) brightness(1.05)'
              }} draggable={false} data-id="element-515" />
              </div>
            </div>
            <div className="p-3 md:p-6 flex-grow flex flex-col justify-between bg-brand-dark/50" data-id="element-516">
              <div className="flex justify-between items-start mb-3 md:mb-6" data-id="element-517">
                <div data-id="element-518">
                  <h3 className="text-sm md:text-xl font-heading font-bold text-white mb-0.5" data-id="element-519">
                    Mexico
                  </h3>
                  <p className="text-[10px] md:text-xs text-gray-400" data-id="element-520">
                    QTAP Smart T-Shirt
                  </p>
                </div>
                <div className="flex flex-col items-end" data-id="element-521">
                  <span className="text-sm md:text-lg font-heading font-bold text-brand-cyan" data-id="element-522">
                    $69.95
                  </span>
                  <span className="text-[10px] md:text-xs text-gray-500 line-through" data-id="element-523">
                    $99.95
                  </span>
                </div>
              </div>
              <a href="https://shop.qtap.me/collections/world-cup-2026-smart-t-shirt" target="_blank" rel="noopener noreferrer" className="w-full block text-center py-2 md:py-3 px-3 border border-white/20 rounded-lg text-xs md:text-sm font-bold text-white hover:bg-brand-cyan hover:border-brand-cyan transition-all duration-300" data-id="element-524">
                Order Now
              </a>
            </div>
          </motion.div>
        </div>

        {/* View All Link */}
        <motion.div initial={{
        opacity: 0,
        y: 10
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5,
        delay: 0.4
      }} className="text-center mt-10 md:mt-16" data-id="element-525">
          <a href="https://shop.qtap.me/collections/world-cup-2026-smart-t-shirt" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 bg-brand-cyan hover:bg-brand-sky text-brand-darkest font-bold text-sm py-3 px-8 rounded-full transition-all hover:-translate-y-0.5" data-id="element-526">
            Explore All Teams Available
          </a>
          <p className="text-xs text-gray-500 mt-3" data-id="element-527">
            10+ national teams — find yours in our full collection
          </p>
        </motion.div>
      </div>
    </section>;
}